export default __webpack_public_path__ + "static/grace1-b54821b43015263a0cdb256392d15294.jpg";